export default "__VITE_ASSET__b1dac06e__"